import { useEffect, useState, useCallback } from 'react';
import useAuth from '../context/AuthProvider';
import { apiClient } from '../helper/api';

// Item 1: State Reports notification badge count, mirrors useInboxUnreadCount
/** Hook to fetch the client's outstanding state report count. Use for the State Reports badge/counter in nav and home. */
export function useStateReportsOutstandingCount(): number {
  const { user } = useAuth();
  const token = user?.token;
  const [outstandingCount, setOutstandingCount] = useState(0);

  const fetchOutstandingCount = useCallback(() => {
    if (!token) return;
    apiClient('/StateReport/StateReportSummary', {
      method: 'GET',
      headers: new Headers({
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      }),
    })
      .then((res: any) => {
        const n = res?.data?.totalOutstanding;
        setOutstandingCount(typeof n === 'number' && n >= 0 ? n : 0);
      })
      .catch(() => setOutstandingCount(0));
  }, [token]);

  useEffect(() => {
    fetchOutstandingCount();
    const interval = setInterval(fetchOutstandingCount, 60 * 1000);
    return () => clearInterval(interval);
  }, [fetchOutstandingCount]);

  return outstandingCount;
}
